var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"lg10":"","offset-lg1":""}},[_c('h2',{staticClass:"text-xs-center"},[_vm._v("Welcome to Galaxie Media Admin Tool")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }